const mixin = {
  displayName: 'Tag',

  isSelected(pk) {
    return this.cursors.selectedTags.exists({ pk })
  },

  getParentTagTree(tagTreeCursor) {
    try {
      const parentTag = tagTreeCursor.up().up().up()
      if (parentTag.get('pk')) {
        return parentTag
      }
    } catch (e) {
      console.error(e)
    }

    return null
  },

  selectTagsTree(initialTagTreeCursor) {
    const selectTagsTreeHelper = (tagTreeCursor) => {
      const pk = tagTreeCursor.get('pk')

      if (!this.isSelected(pk)) {
        this.cursors.selectedTags.push({
          pk,
          name: tagTreeCursor.get('name'),
          approved: tagTreeCursor.get('approved'),
          level: tagTreeCursor.get('level'),
          entryTagGroup: tagTreeCursor.get('entryTagGroup'),
          isRequiredTagGroup: tagTreeCursor.get('isRequiredTagGroup'),
          parentTag: tagTreeCursor.get('parentTag'),
          ancestry: tagTreeCursor.get('ancestry'),
        })
      }

      // Add parent tags recursively
      const parentTagTreeCursor = this.getParentTagTree(tagTreeCursor)
      if (parentTagTreeCursor && parentTagTreeCursor.exists('childrenTags')) {
        selectTagsTreeHelper(parentTagTreeCursor)
      }
    }

    selectTagsTreeHelper(initialTagTreeCursor)
    this.cursors.selectedTags.once('update', () => this.setDirtyState())
  },
}

export default mixin
